import {ExperienceModel} from "../models/experienceModel";
import {ProjectModel} from "../models/projectModel";

const KEY_PLACE_1 = 'w-place-1';
const KEY_PERIOD_1 = 'w-period-1';
const KEY_ADDRESS_1 = 'w-address-1';
const KEY_POSITION_1 = 'w-position-1';
const KEY_DUTIES_1 = 'w-duties-1';

const KEY_PROJECT_NAME_1 = 'p-name-1';
const KEY_PROJECT_LOCATION_1 = 'p-location-1';
const KEY_PROJECT_CLIENT_1 = 'p-client-1';
const KEY_PROJECT_TITLE_1 = 'p-title-1';

const KEY_PLACE_2 = 'w-place-2';
const KEY_PERIOD_2 = 'w-period-2';
const KEY_ADDRESS_2 = 'w-address-2';
const KEY_POSITION_2 = 'w-position-2';
const KEY_DUTIES_2 = 'w-duties-2';

const KEY_PROJECT_NAME_2 = 'p-name-2';
const KEY_PROJECT_LOCATION_2 = 'p-location-2';
const KEY_PROJECT_CLIENT_2 = 'p-client-2';
const KEY_PROJECT_TITLE_2 = 'p-title-2';

const KEY_PLACE_3 = 'w-place-3';
const KEY_PERIOD_3 = 'w-period-3';
const KEY_ADDRESS_3 = 'w-address-3';
const KEY_POSITION_3 = 'w-position-3';
const KEY_DUTIES_3 = 'w-duties-3';

const KEY_PROJECT_NAME_3 = 'p-name-3';
const KEY_PROJECT_LOCATION_3 = 'p-location-3';
const KEY_PROJECT_CLIENT_3 = 'p-client-3';
const KEY_PROJECT_TITLE_3 = 'p-title-3';

const KEY_PROJECT_NAME_4 = 'p-name-4';

let project = new ProjectModel(
	KEY_PROJECT_NAME_1,
	KEY_PROJECT_LOCATION_1,
	KEY_PROJECT_CLIENT_1,
	KEY_PROJECT_TITLE_1
)

let project2 = new ProjectModel(
	KEY_PROJECT_NAME_2,
	KEY_PROJECT_LOCATION_2,
	KEY_PROJECT_CLIENT_2,
	KEY_PROJECT_TITLE_2
)

let project3 = new ProjectModel(
	KEY_PROJECT_NAME_3,
	KEY_PROJECT_LOCATION_3,
	KEY_PROJECT_CLIENT_3,
	KEY_PROJECT_TITLE_3
)

let project4 = new ProjectModel(KEY_PROJECT_NAME_4)

let experience1 = new ExperienceModel(
	KEY_PLACE_1,
	KEY_PERIOD_1,
	KEY_ADDRESS_1,
	KEY_POSITION_1,
	KEY_DUTIES_1,
	[
		project,
	]
);

let experience2 = new ExperienceModel(
	KEY_PLACE_2,
	KEY_PERIOD_2,
	KEY_ADDRESS_2,
	KEY_POSITION_2,
	KEY_DUTIES_2,
	[
		project2,
	]
);

let experience3 = new ExperienceModel(
	KEY_PLACE_3,
	KEY_PERIOD_3,
	KEY_ADDRESS_3,
	KEY_POSITION_3,
	KEY_DUTIES_3,
	[
		project3,
		project4
	]
);

let experience4 = new ExperienceModel(
	'w-place-4',
	'w-period-4',
	'w-address-4',
	'w-position-4',
	'w-duties-4',
	[
		new ProjectModel('p-name-6', 'p-location-6', 'p-client-6', 'p-title-6'),
		new ProjectModel('p-name-5', 'p-location-5', 'p-client-5', 'p-title-5'),
		new ProjectModel('p-name-7', 'p-location-7', 'p-client-7', 'p-title-7'),
		new ProjectModel('p-name-9', 'p-location-9', 'p-client-9', 'p-title-9'),
		new ProjectModel('p-name-8', 'p-location-8', 'p-client-8', 'p-title-8'),
		new ProjectModel('p-name-10', null, null, 'p-title-10'),
	]
);

let experience5 = new ExperienceModel(
	'w-place-5',
	'w-period-5',
	'w-address-5',
	'w-position-5',
	'w-duties-5',
	[
		new ProjectModel('p-name-11', null, null, 'p-title-11'),
	]
);


let experience6 = new ExperienceModel(
	'w-place-6',
	'w-period-6',
	'w-address-6',
	'w-position-6',
	'w-duties-6',
);


let experience7 = new ExperienceModel(
	'w-place-7',
	'w-period-7',
	'w-address-7',
	'w-position-7',
	'w-duties-7',
);

const WorkplaceData = [
	experience4,
	experience5,
	experience1,
	experience2,
	experience3,
	experience6,
	experience7
];

export default WorkplaceData;


